import { Component, EventEmitter, Inject, inject, Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../shared/components/buttons/button/button.component';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-co-traveller',
  standalone: true,
  imports: [ButtonComponent, CommonModule,
    ReactiveFormsModule],
  templateUrl: './co-traveller.component.html',
  styleUrl: './co-traveller.component.scss'
})
export class CoTravellerComponent {
  @Input() isTravellerApplyEnabled: boolean = false;
  @Output() applyTravellers = new EventEmitter<any>();

  travellerForm: FormGroup;
  sectionCount: number = 1;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CoTravellerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) {
    this.travellerForm = this.fb.group({
      travellers: this.fb.array([]),
    });

    this.updateTravellerSections();

    if (data && data.travellers && data.travellers.length > 0) {
      this.sectionCount = data.travellers.length;
      this.initializeForm(data.travellers);
    } else {
      this.sectionCount = 1;
      this.updateTravellerSections();
    }
  }

  get travellers(): FormArray {
    return this.travellerForm.get('travellers') as FormArray;
  }


  initializeForm(travellers: Array<any>): void {
    const travellersArray = this.travellerForm.get('travellers') as FormArray;
    travellersArray.clear();
    travellers.forEach((traveller: any) => {
      travellersArray.push(
        this.fb.group({
          roomNumber: [traveller.roomNumber],
          adults: [traveller.adults, [Validators.min(1)]],
          child: [traveller.child, [Validators.min(0)]],
          infant: [traveller.infant, [Validators.min(0)]],
        })
      );
    });
  }


  incrementSection(): void {
    this.sectionCount++;
    this.updateTravellerSections();
  }

  decrementSection(): void {
    if (this.sectionCount > 1) {
      this.sectionCount--;
      this.updateTravellerSections();
    }
  }

  updateTravellerSections(): void {
    const travellersArray = this.travellerForm.get('travellers') as FormArray;

    const currentLength = travellersArray.length;

    // Add new sections if sectionCount is greater than currentLength
    if (this.sectionCount > currentLength) {
      for (let i = currentLength; i < this.sectionCount; i++) {
        travellersArray.push(
          this.fb.group({
            roomNumber: [i + 1], // Assign numeric room numbers
            adults: [1, [Validators.min(1)]],
            child: [0, [Validators.min(0)]],
            infant: [0, [Validators.min(0)]],
          })
        );
      }
    }

    // Remove extra sections if sectionCount is less than currentLength
    if (this.sectionCount < currentLength) {
      for (let i = currentLength - 1; i >= this.sectionCount; i--) {
        travellersArray.removeAt(i);
      }
    }
  }


  incrementField(index: number, field: string): void {
    const section = this.travellers.at(index);
    const currentValue = section.get(field)?.value;
    section.patchValue({ [field]: currentValue + 1 });
  }

  decrementField(index: number, field: string): void {
    const section = this.travellers.at(index);
    const currentValue = section.get(field)?.value;

    if (field === 'adults' && currentValue > 1) {
      section.patchValue({ [field]: currentValue - 1 });
    } else if (field !== 'adults' && currentValue > 0) {
      section.patchValue({ [field]: currentValue - 1 });
    }
  }

  checkApplyButtonState(): void {
    this.isTravellerApplyEnabled = this.travellers.controls.some(
      (section) => section.get('adults')?.value > 0
    );
  }

  applyTravellerChanges(): void {
    const travellerData = this.travellerForm.value;
    this.dialogRef.close(travellerData);
  }

  closeModal() {
    this.dialogRef.close();
  }
}
